import { planFeatures, plans } from "@/mocks/content";
import { track } from "@/lib/analytics";

export default function Plans() {
  return (
    <section id="planos" className="bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-current" />
              Planos
            </span>
            <h2 className="max-w-2xl font-heading text-3xl font-bold leading-[1.08] tracking-tight text-foreground-950 md:text-5xl">
              Um investimento na{" "}
              <span className="text-primary-500">vontade de pedir.</span>
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-foreground-600">
            A mesma experiência, no período que faz sentido para a sua operação.
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {plans.map((plan, i) => {
            const dark = plan.featured;
            return (
              <div
                key={plan.id}
                className={`reveal relative flex flex-col rounded-2xl border p-7 md:p-8 ${
                  dark
                    ? "border-foreground-900 bg-foreground-950"
                    : "border-background-200 bg-background-50"
                }`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                {plan.tag && (
                  <span className="absolute right-6 top-7 rounded-full bg-primary-500 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-foreground-950 md:right-8 md:top-8">
                    {plan.tag}
                  </span>
                )}

                <h3
                  className={`font-heading text-xl font-bold md:text-2xl ${
                    dark ? "text-foreground-50" : "text-foreground-950"
                  }`}
                >
                  {plan.name}
                </h3>
                <p
                  className={`mt-3 max-w-[15rem] text-sm leading-relaxed ${
                    dark ? "text-foreground-300" : "text-foreground-600"
                  }`}
                >
                  {plan.description}
                </p>

                <div className="mt-8 flex items-end gap-2">
                  <span
                    className={`pb-1 text-sm font-semibold ${
                      dark ? "text-foreground-300" : "text-foreground-600"
                    }`}
                  >
                    R$
                  </span>
                  <span
                    className={`font-heading text-5xl font-bold leading-none tracking-tight ${
                      dark ? "text-foreground-50" : "text-foreground-950"
                    }`}
                  >
                    {plan.price}
                  </span>
                  <span
                    className={`pb-1 text-sm font-medium ${
                      dark ? "text-foreground-400" : "text-foreground-500"
                    }`}
                  >
                    /mês
                  </span>
                </div>

                <span
                  className={`mt-5 inline-flex w-fit rounded-full px-3 py-1 text-xs font-semibold ${
                    dark
                      ? "bg-foreground-800/70 text-foreground-200"
                      : "bg-primary-100 text-primary-700"
                  }`}
                >
                  {plan.badge}
                </span>

                <p
                  className={`mt-4 text-sm ${
                    dark ? "text-foreground-400" : "text-foreground-500"
                  }`}
                >
                  {plan.billing}
                </p>

                <ul
                  className={`mt-6 space-y-3 border-t pt-6 ${
                    dark ? "border-foreground-800/70" : "border-background-200"
                  }`}
                >
                  {planFeatures.map((feature) => (
                    <li key={feature} className="flex items-start gap-3">
                      <i
                        className={`ri-check-line mt-0.5 text-base ${
                          dark ? "text-primary-500" : "text-primary-600"
                        }`}
                        aria-hidden="true"
                      />
                      <span
                        className={`text-sm leading-relaxed ${
                          dark ? "text-foreground-200" : "text-foreground-700"
                        }`}
                      >
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contato"
                  onClick={() => track("plan_cta_click", { plan: plan.id })}
                  className={`mt-8 inline-flex w-full items-center justify-center whitespace-nowrap rounded-full px-6 py-3.5 text-sm font-semibold transition-colors ${
                    dark
                      ? "bg-primary-500 text-foreground-950 hover:bg-primary-400"
                      : "border border-foreground-300 text-foreground-900 hover:border-foreground-900 hover:bg-background-100"
                  }`}
                >
                  {plan.cta}
                </a>
              </div>
            );
          })}
        </div>

        <p className="mt-10 text-center text-sm text-foreground-500">
          Produção de vídeos:{" "}
          <strong className="font-semibold text-foreground-800">
            R$ 4 por vídeo
          </strong>
          . Você escolhe quantos pratos quer colocar em movimento.
        </p>
      </div>
    </section>
  );
}